export const standardColours = {
  black: '#000',
  darkGrey: '#1B1B1B',
  grey: '#EFEFF1',
  lightGrey: '#F9F9FA',
  lighterGrey: '#FCFCFC',
  white: '#FFF',
  transparentBlack: value => {
    return `rgba(0, 0, 0, ${value})`;
  },
  transparentWhite: value => {
    return `rgba(255, 255, 255, ${value})`;
  },
  transparent: 'rgba(255, 255, 255, 0)',
};

export const brandColours = {
  primary: '#32056D', // dark purple
  secondary: '#DF0773', // pink
  tertiary: '#FEB922', // yellow
  quaternary: '#240946', // darker purple
  quinary: '#6114B6', // purple
  senary: '#CBB3E3', // light purple
  septenary: '#ECE4F5', // light pink
  octonary: '#5A10AB', // lighter purple
  nonary: '#8E78AB', // lilac
  denary: '#BCBCCC', // greyish purple
};

export const elementColours = {
  textColour: standardColours.darkGrey,
};
